import { SafariObjectId } from '../base-object/models/app/safari-object-base';

export class PageUiAction {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- we want this
  __requestInfo?: {
    requestDateTime: string;
  };
}
export class RemoveUiitemByIndexRequest extends PageUiAction {
  index: number;
}
export class PageUiActionWithObjectId extends PageUiAction {
  id: SafariObjectId;
}
